import { Controller } from "react-hook-form";
import { TextField, MenuItem, Chip, Box } from "@mui/material";


const FormInput = ({
  name,
  control,
  label,
  rules,
  type = "text",
  select = false,
  options = [],
  multiple = false,  
  ...rest
}) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          label={label}
          type={type}
          select={select}
          error={!!error}
          helperText={error?.message}
          fullWidth
         {...(select && {
            SelectProps: {
              multiple,
              renderValue: multiple
                ? (selected) => (
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                      {(selected as string[])?.map((value) => {
                        const option = options.find(
                          (o) => o.value === value
                        );
                        return (
                          <Chip
                            key={value}
                            label={option?.label || value}
                            size="small"
                          />
                        );
                      })}
                    </Box>
                  )
                : undefined,
            },
          })}
          {...rest}
        >
          {select &&
            options.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
        </TextField>
      )}
    />
  );
};

export default FormInput;



